import {
  FragmentType,
  getFragmentData,
  serverGql,
} from "__generated__/serverGql";
import { makeFormatCurrency } from "utils/formatting";

const fragment = serverGql(/* ServerGraphQL */ `
  fragment StripePriceDescription on StripePrice {
    id
    unitAmount
    currency
    recurringInterval
    recurringIntervalCount
  }
`);

function getCurrencyOptions(currency: string | null | undefined) {
  if (!currency) return {};

  return { currency: currency.toUpperCase() };
}

function formatIntervalCount(count: number, interval: string) {
  if (count === 1) return interval;

  return `${count} ${interval}s`;
}

function formatRecurringInterval(
  recurringInterval: string | null | undefined,
  recurringIntervalCount: number | null | undefined,
) {
  if (!recurringInterval) return null;

  const intervalCount = recurringIntervalCount ?? 1;

  if (intervalCount === 1) return `/${recurringInterval}`;

  return ` every ${formatIntervalCount(intervalCount, recurringInterval)}`;
}

export function getStripePriceDescription(
  stripePrice: FragmentType<typeof fragment>,
): string;
export function getStripePriceDescription(
  stripePrice: FragmentType<typeof fragment> | null | undefined,
): string | undefined;
export function getStripePriceDescription(
  stripePrice: FragmentType<typeof fragment> | null | undefined,
) {
  const price = getFragmentData(fragment, stripePrice);
  const amount = makeFormatCurrency(getCurrencyOptions(price?.currency))(
    price?.unitAmount,
  );

  if (!price) return;

  if (!amount) return "Custom pricing";

  const recurringInterval = formatRecurringInterval(
    price?.recurringInterval,
    price?.recurringIntervalCount,
  );

  return `${amount}${recurringInterval ?? ""}`;
}
